import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from "./login/login.component";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { VerificationComponent } from "./verification/verification.component";
import { LoadingAppComponent } from "./loadingApp/loadingApp.component";
import { LockComponent } from "./lock/lock.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { RegistrationComponent } from "./registration/registration.component";
import { Error404Component } from "./error404/error404.component";
import { LoggedGuard, LockGuard, AuthGuard } from '@guards/auth.guard';
import { UserProfileComponent } from './user-profile/user-profile.component';

const routes: Routes = [
  
  { path: '', component: LoginComponent, canActivate: [ LoggedGuard ] },
  { path: 'verification', component: VerificationComponent, canActivate: [ LockGuard ] },
  { path: 'lock', component: LockComponent, canActivate: [ LockGuard ] },
  { path: 'startapp', component: LoadingAppComponent, canActivate: [ AuthGuard ]},
  
  //OPEN TO PUBLIC ACCESS - NO AUTHENTICATION OR AUTHORIZATION NEEDED
  { path: 'maintenance', component: MaintenanceComponent, canActivate: [ ] },
  { path: 'recovery', component: ForgotPasswordComponent, canActivate: [ ] },
  { path: 'registration', component: RegistrationComponent, canActivate: [ ] },
  { path: '404', component: Error404Component, canActivate: [ ] },
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule { }